import React from 'react';

const Advertising = () => {
  return (
    <div className="w3-white w3-margin">
    <div className="w3-container w3-padding w3-black">
      <h4>Advertise</h4>
    </div>
    <div className="w3-container w3-white">
      <div
        className="w3-container w3-display-container w3-light-grey w3-section"
        style={{ height: 200 }}
      >
        <span className="w3-display-middle">Your AD Here</span>
      </div>
    </div>
  </div>
  );
}

export default Advertising;
